import React, {useState} from "react";
import {
    Dialog, DialogActions, DialogContent, DialogTitle, FormControl,
    FormControlLabel,
    Grid, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText,
    makeStyles, MenuItem, Paper, Select,
    Switch, Typography,
} from "@material-ui/core";
import Controls from "../../components/controls/Controls";
import {connect} from "react-redux";
import {searchCustomersByCode, searchCustomersByName} from "../../redux/customer/CustomerServerAction";
import SettingsIcon from '@material-ui/icons/Settings';
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from '@material-ui/icons/Check';
import ReceiptIcon from '@material-ui/icons/Receipt';
import {searchCustomerOrderNumber} from "../../redux/customer-order-number/CustomerOrderNumberServerActions";
import {green} from "@material-ui/core/colors";

const invoicesPerPage = [
    {
        value: 12,
        text: 12
    },
    {
        value: 24,
        text: 24
    },
    {
        value: 48,
        text: 48
    },
    {
        value: 96,
        text: 96
    },
]

let today = new Date();
function formattedDate(d = new Date()) {
    if(typeof(d) === "string"){
        d = new Date(d);
    }
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return `${day}/${month}/${year}`;
}

const initialFormValues = {
    invoiceNumber: '',
    endDate: today
};
const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        '& .MuiFormControl-root': {
            padding: theme.spacing(1),
            // marginTop: theme.spacing(2)
        },
        '& .MuiCardContent-root': {
            paddingTop: 0,
            paddingBottom: 0,
        },
        '& .MuiCardActions-root': {
            paddingTop: 0,
            paddingBottom: 0,
        }
    },
    searchItemContainer: {
        justifyContent: 'space-between'
    },

    searchByDateContainer: {
        padding: theme.spacing(1)
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    dropDown: {
        width: '80px'
    },
    tranTypeStyle: {
        '& .MuiListItemText-secondary': {
            color: green[500]
        }
    }
}))

function InvoiceSearchForm(props) {
    const [formValues, setFormValues] = useState(initialFormValues);
    const [showSetting, setShowSetting] = React.useState(false);
    const [customerCode, setCustomerCode] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [customerOrderNumber, setCustomerOrderNumber] = useState('');
    const [errors, setErrors] = useState({});
    const [itemPerPageOpen, setItemPerPageOpen] = React.useState(false);
    const handleItemPerPageClose = () => {
        setItemPerPageOpen(false);
    };

    const handleItemPerPageOpen = () => {
        setItemPerPageOpen(true);
    };
    const {
        handleSearchByInvoiceNumber,
        handleSearchByCustomerCode,
        handleSearchByCustomerName,
        handleSearchByCustomerOrderNumber,
        searchByCustomerCode,
        customers,
        searchByCustomerName,
        handleItemPerPageChange,
        invoicePerPage,
        getCurrentTransactions,
        invoicesOnly,
        searchTypeText,
        handleInvoicesOnlyChange,
        searchCustomerOrderNumber,
        customerOrderNumbers,
        supportSalesOrder,
        startDate,
        handleFormValueChange
    } = props;

    const handleClose = () => {
        setShowSetting(false);
    }
    const handleInputChange = e => {
        const {name, value} = e.target;
        setFormValues({
            ...formValues,
            [name]: value
        })

        validate(name, value)
    }

    const handleStartDateChange = e => {
        const {name, value} = e.target;
        handleFormValueChange({name,value})

    }

    const validate = (fieldName, value) => {
        if (fieldName === 'invoiceNumber') {
            validateInvoiceNumberField(value);
        }
    }

    const handleAutoCompleteCustomerCode = (e) => {
        searchByCustomerCode(e.target.value);
    }

    const handleAutoCompleteCustomerOrderNumber = (e) => {
        searchCustomerOrderNumber(invoicesOnly ? 1 : 2, e.target.value);
    }
    const handleAutoCompleteCustomerName = (e) => {
        searchByCustomerName(e.target.value);
    }

    const validateInvoiceNumberField = (invoiceNumber) => {
        let tempErrors = {...errors, customerName: '', customerCode: '', invoiceNumber: '', customerOrderNumber: ''};

        if (!invoiceNumber) {

            tempErrors = {
                ...tempErrors,
                invoiceNumber: `Please enter ${invoicesOnly ? 'invoice' : 'order'} number`
            }
            setErrors(tempErrors)
            return false;
        }
        if (invoiceNumber.length > 20) {

            tempErrors = {
                ...tempErrors,
                invoiceNumber: "Cannot be more than 20 long"
            }
            setErrors(tempErrors)
            return false;
        }
        setErrors(tempErrors)
        return true;
    }


    const validateCustomerNameField = (customerName) => {
        let tempErrors = {...errors, customerName: '', customerCode: '', invoiceNumber: '', customerOrderNumber: ''};

        if (!customerName) {
            tempErrors = {
                ...tempErrors,
                customerName: "Please enter a customer name",
            }
            setErrors(tempErrors)
            return false;
        }
        if (customerName.length > 35) {

            tempErrors = {
                ...tempErrors,
                customerName: "Cannot be more than 35 long",
            }
            setErrors(tempErrors)
            return false;
        }
        setErrors(tempErrors)
        return true;
    }

    const validateCustomerOrderNumberField = (customerOrderNumber) => {
        let tempErrors = {...errors, customerName: '', customerCode: '', invoiceNumber: '', customerOrderNumber: ''};

        if (!customerOrderNumber) {
            tempErrors = {
                ...tempErrors,
                customerOrderNumber: "Please enter customer order number",
            }
            setErrors(tempErrors)
            return false;
        }
        if (customerName.length > 35) {

            tempErrors = {
                ...tempErrors,
                customerOrderNumber: "Cannot be more than 35 long",
            }
            setErrors(tempErrors)
            return false;
        }
        setErrors(tempErrors)
        return true;
    }


    const validateCustomerCodeField = (customerCode) => {
        let tempErrors = {...errors, customerName: '', customerCode: '', invoiceNumber: '', customerOrderNumber: ''};
        if (!customerCode) {

            tempErrors = {
                ...tempErrors,
                customerCode: "Please enter a customer code"
            }
            setErrors(tempErrors)
            return false;
        }
        if (customerCode.length > 10) {
            tempErrors = {
                ...tempErrors,
                customerCode: "Cannot be more than 10 long"
            }
            setErrors(tempErrors)
            return false;
        }
        setErrors(tempErrors)
        return true;
    }

    const findInvoiceAction = (e) => {
        e.preventDefault();
        if (!validateInvoiceNumberField(formValues.invoiceNumber)) return;
        handleSearchByInvoiceNumber(invoicesOnly ? 1 : 2, formValues.invoiceNumber)
        setCustomerCode('')
        setCustomerName('')
        setCustomerOrderNumber('')

    }

    function handleFindByCustomerCode(e) {
        e.preventDefault();

        if (!validateCustomerCodeField(customerCode)) return;
        handleSearchByCustomerCode(invoicesOnly ? 1 : 2, formattedDate(startDate), formattedDate(formValues.endDate), customerCode);
        setCustomerName('')
        setCustomerOrderNumber('')
        setFormValues({
            ...formValues,
            invoiceNumber: ''
        })
    }

    function handleFindByCustomerName(e) {
        e.preventDefault();
        if (!validateCustomerNameField(customerName)) {
            return;
        }
        handleSearchByCustomerName(invoicesOnly ? 1 : 2, formattedDate(startDate), formattedDate(formValues.endDate), customerName)
        setCustomerCode('')
        setCustomerOrderNumber('')
        setFormValues({
            ...formValues,
            invoiceNumber: ''
        })
    }

    function handleFindByCustomerOrderNumber(e) {
        e.preventDefault();
        if (!validateCustomerOrderNumberField(customerOrderNumber)) {
            return;
        }
        handleSearchByCustomerOrderNumber(invoicesOnly ? 1 : 2, customerOrderNumber)
        setCustomerCode('')
        setCustomerName('')
        setFormValues({
            ...formValues,
            invoiceNumber: ''
        })
    }


    const handleCustomerNameAutoCompleteChange = (event, newInputValue) => {
        setCustomerName(newInputValue)
        setErrors({
            customerName: ''
        })
    }

    const handleCustomerCodeAutoCompleteChange = (event, newInputValue) => {
        setCustomerCode(newInputValue)
        setErrors({
            customerCode: ''
        })
    }

    const handleAutoCompleteCustomerOrderNumberChange = (event, newInputValue) => {
        setCustomerOrderNumber(newInputValue)
        setErrors({
            customerOrderNumber: ''
        })
    }
    const handleShowSetting = () => {
        setShowSetting(true);
    }

    const handleRetrieveCurrentTransactions = (e) => {
        e.preventDefault();
        setCustomerName('')
        setCustomerOrderNumber('')
        setCustomerCode('')
        setFormValues({
            ...formValues,
            invoiceNumber: ''
        })
        setErrors({customerName: '', customerCode: '', invoiceNumber: '', customerOrderNumber: ''})
        getCurrentTransactions(invoicesOnly ? 1 : 2);
    }
    const classes = useStyles();
    return (
        <div>


            <Paper className={classes.root}>
                <Grid container className={classes.searchItemContainer}>
                    <Grid item xs={12} md={2}>
                        <Controls.Input
                            name="invoiceNumber"
                            label={`${searchTypeText} Number`}
                            value={formValues.invoiceNumber}
                            onChange={handleInputChange}
                            error={errors.invoiceNumber}
                            inputProps={{maxLength: 20}}
                        />
                        <Controls.Button
                            text={`Find By ${searchTypeText} Number`}
                            onClick={findInvoiceAction}/>
                    </Grid>
                    <Grid item xs={12} md={2}>

                        <Controls.AutoCompleteSelect
                            options={customerOrderNumbers.orderNumbers || []}
                            inputValue={customerOrderNumber}
                            autoCompleteInputChange={handleAutoCompleteCustomerOrderNumberChange}
                            noOptionsText={customerOrderNumber ? 'No order number found' : "Start typing to find order number"}
                            inputTextChange={handleAutoCompleteCustomerOrderNumber}
                            inputLabelText="Search customer order number"
                            getOptionLabel={option =>
                                typeof option === "string" ? option : option.orderNumber
                            }
                            renderOption={option => {
                                return (
                                    <Grid container alignItems="center">
                                        <Grid item xs>
                                            {option.orderNumber}
                                        </Grid>
                                    </Grid>
                                );
                            }}
                            error={errors.customerOrderNumber}
                        />
                        <Controls.Button
                            text={`Find ${searchTypeText} by customer order number`}
                            onClick={handleFindByCustomerOrderNumber}/>

                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Controls.AutoCompleteSelect
                            options={customers.customersByCode || []}
                            inputValue={customerCode}
                            autoCompleteInputChange={handleCustomerCodeAutoCompleteChange}
                            noOptionsText={customerCode ? 'No customer found' : "Start typing to search customer"}
                            inputTextChange={handleAutoCompleteCustomerCode}
                            inputLabelText="Search customer code"
                            getOptionLabel={option =>
                                typeof option === "string" ? option : option.code
                            }
                            renderOption={option => {
                                return (
                                    <Grid container alignItems="center">
                                        <Grid item xs>
                                            {option.code} - {option.name}
                                        </Grid>
                                    </Grid>
                                );
                            }}
                            error={errors.customerCode}
                        />


                        <Controls.Button
                            text={`Find ${searchTypeText} by customer code`}
                            onClick={handleFindByCustomerCode}/>

                    </Grid>

                    <Grid item xs={12} md={2}>

                        <Controls.AutoCompleteSelect
                            options={customers.customersByName || []}
                            inputValue={customerName}
                            autoCompleteInputChange={handleCustomerNameAutoCompleteChange}
                            noOptionsText={customerName ? 'No customer found' : "Start typing to search customer"}
                            inputTextChange={handleAutoCompleteCustomerName}
                            inputLabelText="Search customer name"
                            getOptionLabel={option =>
                                typeof option === "string" ? option : option.name
                            }
                            renderOption={option => {
                                return (
                                    <Grid container alignItems="center">
                                        <Grid item xs>
                                            {option.name}
                                        </Grid>
                                    </Grid>
                                );
                            }}
                            error={errors.customerName}
                        />
                        <Controls.Button
                            text={`Find ${searchTypeText} by customer name`}
                            onClick={handleFindByCustomerName}/>

                    </Grid>

                    <Grid item xs={12} md={2}>
                        <Controls.Button
                            variant="text"
                            text={`Retrieve ${invoicesOnly ? 'invoices' : 'orders'} for today`}
                            onClick={handleRetrieveCurrentTransactions}
                            startIcon={<ReceiptIcon>Retrieve</ReceiptIcon>}
                        />
                        <Controls.Button
                            variant="text"
                            text="More option"
                            onClick={handleShowSetting}
                            startIcon={<SettingsIcon>More option</SettingsIcon>}
                        />
                    </Grid>
                </Grid>

            </Paper>
            <Dialog open={showSetting} onClose={handleClose}
                    maxWidth='sm'
                    fullWidth={true}
                    aria-labelledby="form-dialog-title">
                <DialogTitle disableTypography>
                    <Typography variant='h6' color='textSecondary'>
                        Update setting
                    </Typography>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <div>
                        <List>
                            {supportSalesOrder ?
                                <ListItem divider>

                                    <ListItemText id="retrieve-invoice-label" primary={'Transaction type'}
                                                  secondary={`Selected - ${searchTypeText}`}
                                                  className={classes.tranTypeStyle}/>
                                    <ListItemSecondaryAction>
                                        <FormControlLabel
                                            control={<Switch checked={invoicesOnly}
                                                             onChange={handleInvoicesOnlyChange}/>}
                                            label='Invoice'
                                        />
                                    </ListItemSecondaryAction>
                                </ListItem> : null}

                            <ListItem divider>
                                <ListItemText id="item-per-page-label" primary={`${searchTypeText} per page`}/>
                                <ListItemSecondaryAction>
                                    <FormControl className={classes.dropDown}>
                                        <Select
                                            open={itemPerPageOpen}
                                            onClose={handleItemPerPageClose}
                                            onOpen={handleItemPerPageOpen}
                                            value={invoicePerPage}
                                            onChange={handleItemPerPageChange}>
                                            {invoicesPerPage && invoicesPerPage.map(item => {
                                                return <MenuItem key={item.value}
                                                                 value={item.value}>{item.text}</MenuItem>
                                            })}
                                        </Select>

                                    </FormControl>
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <Typography>{searchTypeText} range</Typography>
                            </ListItem>
                            <ListItem>
                                <Controls.DatePicker
                                    name='startDate'
                                    label="Start Date"
                                    value={startDate}
                                    onChange={handleStartDateChange}/>
                            </ListItem>
                            <ListItem divider>
                                <Controls.DatePicker
                                    name='endDate'
                                    label="End Date"
                                    value={formValues.endDate}
                                    onChange={handleInputChange}/>
                            </ListItem>
                        </List>
                    </div>

                </DialogContent>
                <DialogActions>
                    <Controls.Button
                        startIcon={<CheckIcon/>}
                        onClick={handleClose}
                        text="Done"
                    />
                </DialogActions>
            </Dialog>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        customers: state.customers,
        customerOrderNumbers: state.customerOrderNumbers
    }
}

const mapDispatchToProps = dispatch => {
    return {
        searchByCustomerCode: (searchKey) => searchCustomersByCode(searchKey),
        searchByCustomerName: (searchKey) => searchCustomersByName(searchKey),
        searchCustomerOrderNumber: (type, searchKey) => searchCustomerOrderNumber(type, searchKey)
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps()
)(InvoiceSearchForm);
